import React, { useEffect, useState } from "react";
import { Logo } from "@/components/Logo";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-stone-950/80 backdrop-blur-2xl border-b border-stone-800/80"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-20 flex items-center justify-between gap-8">
        {/* Left: Logo */}
        <Logo />

        {/* Right: Nav */}
        <nav className="hidden md:flex items-center gap-10 font-proxima text-[11px] uppercase tracking-[0.22em] text-stone-300 font-medium">
          <a
            href="#expect"
            onClick={scrollTo("expect")}
            className="link-underline hover:text-stone-50"
            data-testid="nav-link-expect"
          >
            What to Expect
          </a>
          <a
            href="#flavours"
            onClick={scrollTo("flavours")}
            className="link-underline hover:text-stone-50"
            data-testid="nav-link-flavours"
          >
            Flavours
          </a>
          <a
            href="#quality"
            onClick={scrollTo("quality")}
            className="link-underline hover:text-stone-50"
            data-testid="nav-link-quality"
          >
            Quality
          </a>
          <a
            href="#catering"
            onClick={scrollTo("catering")}
            className="link-underline hover:text-stone-50"
            data-testid="nav-link-catering"
          >
            Catering
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
